import WidgetSetUpp from './component'

export default WidgetSetUpp
